import React from 'react';
import { Link } from 'react-router-dom';

const SitemapPage = ({ menuItems, language }) => {
  return (
    <div className="min-h-screen bg-[#FAF6EE] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto bg-white p-6 sm:p-8 rounded-xl shadow-md border-t-4 border-[#D4AF37]">
        <h1 className="text-2xl sm:text-3xl font-bold text-[#1A237E] mb-6 border-b pb-4 flex items-center gap-2">
          <span>🗺️</span>
          <span>{language === 'en' ? 'Site Map (3-Tier Navigation Index)' : 'தள வரைபடம் (3-அடுக்கு வழிசெலுத்தல்)'}</span>
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {menuItems.map((section, idx) => (
            <div key={idx} className="bg-[#FAF6EE] p-5 rounded-lg shadow-sm border border-[#F5EDDA]">
              <h2 className="text-lg font-bold text-[#CC6600] mb-3 border-b-2 border-[#D4AF37] pb-1 flex items-center justify-between">
                <Link to={section.slug} className="hover:underline">
                  {language === 'en' ? section.label_en : section.label_ta}
                </Link>
                <span className="text-xs text-[#2D5A1E]">Tier 1</span>
              </h2>

              {section.subMenus ? (
                <div className="space-y-4 mt-2">
                  {section.subMenus.map((sub, sidx) => (
                    <div key={sidx} className="bg-white p-3 rounded border border-[#FAF6EE]">
                      <h3 className="text-sm font-bold text-[#1A237E] mb-1">
                        <Link to={sub.slug} className="hover:underline">
                          {language === 'en' ? sub.label_en : sub.label_ta}
                        </Link>
                      </h3>
                      {sub.pages && (
                        <ul className="space-y-1 pl-4 border-l-2 border-[#D4AF37]">
                          {sub.pages.map((p, pidx) => (
                            <li key={pidx} className="text-xs text-gray-700">
                              <Link to={p.slug} className="hover:text-[#CC6600] hover:underline transition-colors block py-0.5">
                                • {language === 'en' ? p.label_en : p.label_ta}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              ) : section.children ? (
                <ul className="space-y-2 mt-2">
                  {section.children.map((child, cidx) => (
                    <li key={cidx} className={child.isHeader ? 'mt-3 mb-1 font-bold text-xs text-[#CC6600]' : 'ml-3 list-disc text-xs text-gray-700'}>
                      {!child.isHeader && (
                        <Link to={child.slug} className="hover:text-[#1A237E] hover:underline">
                          {language === 'en' ? child.label_en : child.label_ta}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SitemapPage;
